export const setCookie = ({ name, value }: { name: string; value: string }) => {
  const existingCookiesArray = document.cookie.split('; ');
  const cookie = `${name}=${value}`;
  const documentHasCookie = !!existingCookiesArray?.includes(cookie);

  if (!documentHasCookie) {
    document.cookie = `${cookie}; domain=getweave.com; path=/`;
  }
};
